<template>
  <div>
    <b-card no-body >
      <b-card-body>
        <b-row>
          <b-col lg="3">
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  class="mr-1"
                  @click="traerProductos"
              >
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
              </b-button>
              <b-button
                  variant="gradient-primary"
                  @click="exportarFileV2"
                  :disabled="loading_exp"
                  size="sm"
              >
                <feather-icon
                    :icon="`${loading_exp ? 'RefreshCwIcon' : 'FileTextIcon'}`"
                    :class="`${loading_exp ? 'spinner' : ''}`"
                />
                <span v-if="loading_exp">&emsp; Generando Excel</span>
              </b-button>
            </b-form-group>
          </b-col>
          <b-col lg="9">
            Total de Productos: {{ items.length }}
          </b-col>
        </b-row>
      </b-card-body>

      <b-table
          hover
          responsive
          small
          sticky-header="58vh"
          class="position-relative"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>

import {
  BBadge,
  BButton,
  BCard,
  BCardBody, BCol, BFormGroup, BRow,
  BSpinner,
  BTable,
} from 'bootstrap-vue'
import axiosIns from '../../../libs/axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BButton,
    BCol,
    BRow,
    BFormGroup,
  },
  directives: {

  },
  data: () => ({
    loading: false,
    loading_exp: false,
    items: [],
    totalRows: 0,
    sortBy: 'idmaterial',
    sortDesc: false,
    sortDirection: 'asc',
    fields: [
      {
        key: 'idmaterial',
        label: 'ID Material',
        sortable: true,
      },
      {
        key: 'nombre_material',
        label: 'Producto',
        sortable: true,
      },
      {
        key: 'nombre_grupo_articulo',
        label: 'Grupo',
        sortable: true,
      },
      {
        key: 'unidad_medida_base',
        label: 'U.M',
        sortable: true,
      }
    ],

  }),
  computed: {},
  mounted() {
    this.traerProductos();
  },
  methods: {
    traerProductos(){
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/pagricolas/articulos/all/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data
              yo.totalRows = yo.items.length
            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          })

    },

    exportarFileV2(){
      const yo = this
      yo.loading_exp = true

      const config = {
        method: 'get',
        url: '/pagricolas/productos/exportar/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;

              const hoy = new Date();
              const fecha_hora = hoy.getFullYear() +''+ ( hoy.getMonth() + 1 ) +''+ hoy.getDate() +''+ hoy.getHours() +''+ hoy.getMinutes() +''+ hoy.getSeconds()

              fileLink.setAttribute('download', "Reporte de Productos - "+ fecha_hora +".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading_exp = false
          });

    },
  },
}
</script>

<style lang="scss">
</style>
